// TOP LEVEL IMPORTS
import React from 'react';
// ANTD
import Table from 'antd/lib/table';
// MODULES
import GeneralHelpers from 'lib/helpers/GeneralHelpers';
// COMPONENTS
import ActionMenu from './ActionMenu';
import Tag from 'components/common/Tag';

const MOBILE_COLUMNS = [
  {
    title: 'TYPE',
    dataIndex: 'contractType',
    key: '_id',
  },
  {
    title: 'STATUS',
    dataIndex: 'status',
    key: 'status',
    render: (text, record) => {
      switch (record.status) {
      case 'DRAFT':
        return <Tag>DRAFT</Tag>;
      case 'AWAITING':
        return <Tag color="yellow">AWAITING</Tag>;
      case 'SIGNED':
        return <Tag color="green">SIGNED</Tag>;
      default:
        return null;
      }
    },
  },
  // {
  //   title: 'CREATED',
  //   dataIndex: 'createdAt',
  //   key: 'createdAt',
  //   render: (text, record) => <div>{GeneralHelpers.formatTableDate(record.createdAt)}</div>,
  // },
  {
    title: 'ACTIONS',
    width: 85,
    render: (text, record) => <ActionMenu record={record} />,
  },
];

const FULL_SCREEN_COLUMNS = [
  {
    title: 'TYPE',
    dataIndex: 'contractType',
    key: '_id',
  },
  {
    title: 'STATUS',
    dataIndex: 'status',
    key: 'status',
    render: (text, record) => {
      switch (record.status) {
      case 'DRAFT':
        return <Tag>DRAFT</Tag>;
      case 'AWAITING':
        return <Tag color="yellow">AWAITING</Tag>;
      case 'SENT':
        return <Tag color="blue">SENT</Tag>;
      case 'SIGNED':
        return <Tag color="green">SIGNED</Tag>;
      default:
        return null;
      }
    },
  },
  {
    title: 'CREATED',
    dataIndex: 'createdAt',
    key: 'createdAt',
    render: (text, record) => <div>{GeneralHelpers.formatTableDate(record.createdAt)}</div>,
  },
  {
    title: 'ACTIONS',
    width: 85,
    render: (text, record) => <ActionMenu record={record} />,
  },
];

const ContractsTable = ({ contracts, windowWidth }) => (
  <Table
    rowKey={record => record._id}
    columns={windowWidth < 789 ? MOBILE_COLUMNS : FULL_SCREEN_COLUMNS}
    dataSource={contracts}
    pagination={{
      defaultPageSize: 5,
    }}
  />
);

export default ContractsTable;



// WEBPACK FOOTER //
// ./src/routes/app-client-detail/ClientContracts/ContractsTable/index.js